import React from 'react';
import {
  HomeContainer,
  ContentContainer,
  TitleContainer,
  TitleHike,
  TitleMatters,
  IdeaTitle,
  IdeaContent,
  DescriptionContainer,
  TitleBox,
  SectionContainer,
  SectionDivider,
  IconSection,
  IconContainer,
  IconTitle,
  IconDescription,
} from './Home.styles';
import logoIconBasic from '../../../assets/images/logo_basic.png';
import { useTranslation } from 'react-i18next';

// Ikony SVG
const CommunityIcon = () => (
  <svg
    width="60"
    height="60"
    viewBox="0 -960 960 960"
    fill="none"
    stroke="currentColor"
    strokeWidth="0"
  >
    <path
      d="M0-240v-63q0-43 44-70t116-27q13 0 25 .5t23 2.5q-14 21-21 44t-7 48v65H0Zm240 0v-65q0-32 17.5-58.5T307-410q32-20 76.5-30t96.5-10q53 0 97.5 10t76.5 30q32 20 49 46.5t17 58.5v65H240Zm540 0v-65q0-26-6.5-49T754-397q11-2 22.5-2.5t23.5-.5q72 0 116 26.5t44 70.5v63H780Zm-455-80h311q-10-20-55.5-35T480-370q-55 0-100.5 15T325-320ZM160-440q-33 0-56.5-23.5T80-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T160-440Zm640 0q-33 0-56.5-23.5T720-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T800-440Zm-320-40q-50 0-85-35t-35-85q0-51 35-85.5t85-34.5q51 0 85.5 34.5T600-600q0 50-34.5 85T480-480Zm0-80q17 0 28.5-11.5T520-600q0-17-11.5-28.5T480-640q-17 0-28.5 11.5T440-600q0 17 11.5 28.5T480-560Zm1 240Zm-1-280Z"
      fill="currentColor"
      stroke="none"
    />
  </svg>
);

const TreeIcon = () => (
  <svg
    width="60"
    height="60"
    viewBox="0 -960 960 960"
    fill="none"
    stroke="currentColor"
    strokeWidth="0"
  >
    <path
      d="M280-80v-160H0l154-240H80l280-400 120 172 120-172 280 400h-74l154 240H680v160H520v-160h-80v160H280Zm389-240h145L659-560h67L600-740l-71 101 111 159h-74l103 160Zm-523 0h428L419-560h67L360-740 234-560h67L146-320Zm0 0h155-67 252-67 155-428Zm523 0H566h74-111 197-67 155-145Zm-149 80h160-160Zm201 0Z"
      fill="currentColor"
      stroke="none"
    />
  </svg>
);

const MountainIcon = () => (
  <svg
    width="60"
    height="60"
    viewBox="0 -960 960 960"
    fill="none"
    stroke="currentColor"
    strokeWidth="0"
  >
    <path
      d="m46-160 138-276q10-20 28.5-32t41.5-12q24 0 44 12.5t29 35.5l27 66q2 6 9 5.5t9-6.5l86-287q14-48 53.5-77t89.5-29q49 0 87.5 28.5T742-657l173 497h-85L666-632q-8-23-25-35.5T601-680q-23 0-40.5 13T535-631l-86 287q-9 28-32.5 46T363-280q-27 0-50-14.5T280-335l-27-66-118 241H46Zm194-400q-50 0-85-35.5T120-680q0-50 35-85t85-35q50 0 85 35t35 85q0 49-35 84.5T240-560Zm0-80q17 0 28.5-11.5T280-680q0-17-11.5-28.5T240-720q-17 0-28.5 11.5T200-680q0 17 11.5 28.5T240-640Zm123 360ZM240-680Z"
      fill="currentColor"
      stroke="none"
    />
  </svg>
);

export const Home = () => {
  const { t } = useTranslation();

  const activities = t('home.list2', { returnObjects: true }) as string[];

  return (
    <div>
      {/* HERO SECTION */}
      <HomeContainer>
        <ContentContainer>
          <TitleBox>
            <img src={logoIconBasic} alt="logo" height="80" />
            <TitleContainer>
              <TitleHike>HIKE</TitleHike>
              <TitleMatters>MATTERS</TitleMatters>
            </TitleContainer>
          </TitleBox>

          <DescriptionContainer>
            <IdeaTitle>{t('home.title')}</IdeaTitle>
            <IdeaContent>{t('home.description')}</IdeaContent>
          </DescriptionContainer>
        </ContentContainer>
      </HomeContainer>

      {/* SEKCJA: CO ROBIMY */}
      <SectionContainer>
        <IconSection>
          <IconContainer>
            <MountainIcon />
            <IconTitle>{t('home.activity-titles.mountain-expeditions')}</IconTitle>
            <IconDescription>{activities[0]}</IconDescription>
          </IconContainer>

          <IconContainer>
            <TreeIcon />
            <IconTitle>{t('home.activity-titles.forest-trekking')}</IconTitle>
            <IconDescription>{activities[1]}</IconDescription>
          </IconContainer>

          <IconContainer>
            <CommunityIcon />
            <IconTitle>{t('home.activity-titles.women-community')}</IconTitle>
            <IconDescription>{activities[2]}</IconDescription>
          </IconContainer>
        </IconSection>
      </SectionContainer>

      <SectionDivider />
    </div>
  );
};
